import { LinkBox } from "components";
import PropTypes from "prop-types";

const LinkBoxAdapter = ({ blok }) => {
  const linkItems = blok.body.map(({ anchorText, url }) => ({ url: url.url || "/", anchorText }));

  return <LinkBox linkItems={linkItems} />;
};

export default LinkBoxAdapter;

LinkBoxAdapter.propTypes = {
  blok: PropTypes.shape({
    body: PropTypes.arrayOf(
      PropTypes.shape({ anchorText: PropTypes.string, url: PropTypes.shape({ url: PropTypes.string }) })
    ),
  }).isRequired,
};
